import { useEffect } from "react";
import { useInfiniteQuery, useQueryClient, useMutation } from "react-query";
import qs from "qs-lite";

import api from "../../utils/api";

const SEARCH = "/search";

const getSearchData = ({ queryKey, pageParam = 0 }) => {
  const query = queryKey[1]?.query;
  const queryString = qs.stringify({ query, skip: pageParam, take: 10 });
  return api.get(`${SEARCH}?${queryString}`);
};

export const useGetSearchData = (query) => {
  const queryClient = useQueryClient();
  
  useEffect(() => {
    queryClient.cancelQueries({
      predicate: (q) => q.queryKey[0] === SEARCH,
      exact: false,
    });
  }, [query, queryClient]);

  return useInfiniteQuery([SEARCH, { query }], getSearchData, {
    retry: false,
    enabled: !!query,
    getNextPageParam: (lastPage, allPages) => {
      // Check if any category has more results
      const hasMore = lastPage?.results?.some((category) => category.hasMore);
      if (hasMore) {
        return allPages.length * 10; // skip = page number * take
      }
      return undefined;
    },
  });
};

// Hook for loading more results from a specific category
export const useLoadMoreCategory = () => {
  return useMutation(
    ({ searchQuery, category, skip }) => {
      const queryString = qs.stringify({ 
        query: searchQuery, 
        category, 
        skip, 
        take: 10 
      });
      return api.get(`${SEARCH}?${queryString}`);
    },
    {
      retry: false,
    }
  );
};
